"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderInternal = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var ListingsActions = _interopRequireWildcard(require("../listings/listingsModule"));
var _AnalyticsModule = require("../analytics/modules/AnalyticsModule");
var _SearchBar = _interopRequireDefault(require("./SearchBar"));
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/Header.css") : void 0;
var _utils = require("../utils");
var _withRouter = require("../HOCs/withRouter");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var HeaderInternal = exports.HeaderInternal = function HeaderInternal(_ref) {
  var navigate = _ref.navigate,
    location = _ref.location,
    resetSearchAndFilters = _ref.resetSearchAndFilters,
    listingsReadyState = _ref.listingsReadyState,
    meta = _ref.meta;
  var handleHeaderClick = function handleHeaderClick() {
    resetSearchAndFilters();
    navigate((0, _utils.getAppCenterPathName)(location.pathname), {
      replace: true
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", null, !meta.listingNotFound && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-7"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "appcenter-title",
    onClick: handleHeaderClick
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "AppCenterHeader"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-5 col-xs-12"
  }, listingsReadyState === ListingsActions.LISTINGS_FETCHED && /*#__PURE__*/_react.default.createElement(_SearchBar.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 appcenter-help"
  }, location.pathname.split('/').pop() !== 'help' && /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
    to: "".concat((0, _utils.getAppCenterPathName)(location.pathname), "/help")
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "HelpPageNeedHelp"
  }))))), /*#__PURE__*/_react.default.createElement(_reactRouter.Outlet, null)));
};
HeaderInternal.propTypes = {
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  navigate: _propTypes.default.func.isRequired,
  // eslint-disable-line react/forbid-prop-types
  resetSearchAndFilters: _propTypes.default.func.isRequired,
  meta: _propTypes.default.shape({
    listingNotFound: _propTypes.default.bool
  })
};
var Header = /*#__PURE__*/function (_Component) {
  function Header() {
    _classCallCheck(this, Header);
    return _callSuper(this, Header, arguments);
  }
  _inherits(Header, _Component);
  return _createClass(Header, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(HeaderInternal, this.props));
    }
  }]);
}(_react.Component);
function mapStateToProps(state) {
  return {
    meta: state.meta,
    listingsReadyState: state.listings.listingsReadyState
  };
}
var mappedHeader = (0, _reactRedux.connect)(mapStateToProps, {
  trackCategoryLinkClick: _AnalyticsModule.linkClickDispatch,
  resetSearchAndFilters: ListingsActions.resetSearchAndFilters
})(Header);
var _default = exports.default = (0, _withRouter.withRouter)(mappedHeader);